import utils from './index';

export function mmgaevent(action, label = 'label') {
  utils.gaEvent('m_Download', action, label + '');
}
export function mmgaevent1(action, label = 'label') {
  utils.gaEvent('p_Download', action, label + '');
}
